(() => {
  if (window.Sn33Newsletter) { window.Sn33Newsletter.init(document); return; }
  const instances = new Map();
  const visitStates = new Map();
  const saveVisit = (key, state) => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  };
  const currentVisit = key => {
    if (visitStates.has(key)) return visitStates.get(key);
    let stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
    const now = Date.now();
    const navigationType = window.performance?.getEntriesByType?.('navigation')?.[0]?.type || 'navigate';
    let externalArrival = !document.referrer;
    try { if (document.referrer) externalArrival = new URL(document.referrer).origin !== location.origin; } catch (_) { externalArrival = true; }
    const validVisit = stored && Number.isFinite(stored.updatedAt) && typeof stored.entryPath === 'string';
    const newVisit = !validVisit || now - stored.updatedAt >= 30 * 60000 ||
      (navigationType === 'navigate' && externalArrival) ||
      (navigationType === 'reload' && stored.entryPath === location.pathname);
    const state = newVisit ? { shown: false, entryPath: location.pathname, updatedAt: now } : { ...stored, updatedAt: now };
    visitStates.set(key, state);
    saveVisit(key, state);
    return state;
  };
  const init = scope => {
    const roots = scope.matches?.('[data-sn33-newsletter]') ? [scope] : scope.querySelectorAll('[data-sn33-newsletter]');
    roots.forEach(root => {
      if (instances.has(root)) return;
      const dialog = root.querySelector('[data-sn33-dialog]');
      const trigger = root.querySelector('[data-sn33-open]');
      const band = root.querySelector('[data-sn33-band]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const success = dialog.querySelector('[data-sn33-success]');
      let response = !!(success || dialog.querySelector('[data-sn33-error]'));
      let ageReady = false, shown = false, frame = 0, retry = 0, timer = 0;
      let lastFocus = null, scrollState = null;
      const visitKey = `${root.dataset.storageKey}.visit.v2`;
      const visit = currentVisit(visitKey);
      if (success || root.dataset.subscriber === 'true') {
        visit.subscribed = true;
        saveVisit(visitKey, visit);
      }
      if (!response && visit.subscribed && root.dataset.subscriber !== 'true') {
        const form = dialog.querySelector('form');
        const confirmedTemplate = dialog.querySelector('[data-sn33-confirmed-template]');
        if (form && confirmedTemplate) form.replaceChildren(confirmedTemplate.content.cloneNode(true));
      }
      if (success || dialog.querySelector('[data-sn33-confirmed]')) {
        const signupOffer = dialog.querySelector('[data-sn33-offer-signup]');
        const confirmedOffer = dialog.querySelector('[data-sn33-offer-confirmed]');
        if (signupOffer) signupOffer.hidden = true;
        if (confirmedOffer) confirmedOffer.hidden = false;
      }
      const trackActivity = () => {
        const now = Date.now();
        if (now - visit.updatedAt < 15000) return;
        visit.updatedAt = now;
        saveVisit(visitKey, visit);
      };
      const blocked = automatic => {
        if (window.Sn84CartState?.busy?.()) return true;
        if (document.body.classList.contains('overflow-hidden')) return true;
        if (automatic && document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
        return Array.from(document.querySelectorAll('dialog[open],cart-drawer.active,cart-notification.active,.drawer.active,[aria-modal="true"],details[open].menu-drawer-container')).some(node => {
          if (node === dialog || dialog.contains(node)) return false;
          const box = node.getBoundingClientRect();
          return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 && box.top < window.innerHeight && box.left < window.innerWidth && getComputedStyle(node).visibility !== 'hidden';
        });
      };
      const unlock = () => {
        if (!scrollState) return;
        document.body.style.overflow = scrollState.overflow;
        document.body.style.paddingRight = scrollState.padding;
        scrollState = null;
      };
      const open = (automatic = false) => {
        if (dialog.open || document.hidden || blocked(automatic)) return false;
        lastFocus = document.activeElement;
        const gutter = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        scrollState = { overflow: document.body.style.overflow, padding: document.body.style.paddingRight };
        if (gutter) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + gutter}px`;
        document.body.style.overflow = 'hidden';
        try { dialog.showModal(); } catch (_) { unlock(); return false; }
        shown = true;
        visit.shown = true;
        visit.updatedAt = Date.now();
        saveVisit(visitKey, visit);
        clearTimeout(timer); clearTimeout(retry);
        window.removeEventListener('scroll', queue);
        requestAnimationFrame(() => {
          if (dialog.open) (dialog.querySelector('[data-sn33-error],[data-sn33-success],[data-sn33-confirmed]') || dialog.querySelector('[data-sn33-close]'))?.focus({ preventScroll: true });
        });
        return true;
      };
      const schedule = () => {
        if (!retry) retry = setTimeout(() => { retry = 0; check(); }, 1800);
      };
      const check = () => {
        if (!root.isConnected || dialog.open || document.hidden) return;
        if (response) { if (open()) response = false; else schedule(); return; }
        if (shown || visit.shown || root.dataset.auto !== 'true' || !ageReady) return;
        if (/\/(cart|checkout|challenge|account)(\/|$)/.test(location.pathname)) return;
        if (!open(true)) schedule();
      };
      const queue = () => {
        if (!frame) frame = requestAnimationFrame(() => { frame = 0; check(); });
      };
      const canRestoreFocus = element => {
        if (!element?.isConnected || element === document.body || typeof element.focus !== 'function') return false;
        if (element.matches(':disabled,[aria-disabled="true"]') || element.closest('[hidden],[inert],[aria-hidden="true"],dialog:not([open])')) return false;
        if (!element.getClientRects().length) return false;
        for (let ancestor = element; ancestor; ancestor = ancestor.parentElement) {
          const style = getComputedStyle(ancestor);
          if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
        }
        return true;
      };
      const close = () => {
        unlock();
        const focusTarget = [lastFocus, trigger, ...document.querySelectorAll('.header__heading-link[href]')].find(canRestoreFocus);
        focusTarget?.focus({ preventScroll: true });
      };
      const click = event => {
        const opener = event.target.closest('[data-sn33-open]');
        if (opener && (root.contains(opener) || opener.dataset.sn33Open === dialog.id)) {
          open(); return;
        }
        if (dialog.contains(event.target.closest('[data-sn33-close]'))) { dialog.close(); return; }
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      };
      if (trigger) {
        trigger.hidden = false;
        if (band) band.hidden = trigger.hidden;
      }
      dialog.addEventListener('close', close);
      document.addEventListener('click', click);
      document.addEventListener('visibilitychange', queue);
      document.addEventListener('close', queue, true);
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('scroll', trackActivity, { passive: true });
      window.addEventListener('pointerdown', trackActivity, { passive: true });
      window.addEventListener('keydown', trackActivity);
      // Sur mobile, laisser le temps de découvrir la page avant l'offre.
      const welcomeDelay = window.matchMedia('(max-width: 749px)').matches ? 20000 : 4000;
      timer = setTimeout(() => { ageReady = true; check(); }, welcomeDelay);
      instances.set(root, () => {
        clearTimeout(timer); clearTimeout(retry); cancelAnimationFrame(frame);
        dialog.removeEventListener('close', close);
        document.removeEventListener('click', click);
        document.removeEventListener('visibilitychange', queue);
        document.removeEventListener('close', queue, true);
        window.removeEventListener('scroll', queue);
        window.removeEventListener('scroll', trackActivity);
        window.removeEventListener('pointerdown', trackActivity);
        window.removeEventListener('keydown', trackActivity);
        if (dialog.open) dialog.close();
        unlock();
      });
      check();
    });
  };
  const destroy = scope => {
    instances.forEach((cleanup, root) => {
      if (scope === root || scope.contains(root)) { cleanup(); instances.delete(root); }
    });
  };
  window.Sn33Newsletter = { init, destroy };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

